import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import GalleryPage from './GalleryPage';
import SpecimenPage from './SpecimenPage';
import NotFound from './NotFound';
import useDocumentTitle from './useDocumentTitle';
import './App.css';

export default function App() {

  // One place, above the route table, because a title is a property of the route
  // rather than of any page's contents — and doing it here means a new route gets
  // a title by being added to metaForPath, not by remembering to call a hook.
  useDocumentTitle();

  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home />} />
        {/* The generator, already running. Every "start zooming" link in the app
            points here rather than at `/`: someone arriving from a share link, a
            saved gallery or a 404 has already said yes, and the pitch would only
            ask them again. It is a real route, not a flag on `/`, so it survives a
            refresh and can be linked from outside the app. */}
        <Route path='/explore' element={<Home explore />} />
        <Route path='/gallery' element={<GalleryPage />} />
        {/* The shareable deep link. Deliberately outside /gallery: it is one
            specimen shown to someone who may have no gallery of their own. */}
        <Route path='/g/:token' element={<SpecimenPage />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </div>
  );
};
